import React from 'react'
import { withStyles } from '@material-ui/core';
import Button from 'components/Button';

const style = theme => ({
	button: {
		color: theme.palette.primary.contrastText,
		marginLeft: theme.spacing(1),
	},
})

function InfoBarTitleButton({
	classes,
	onClick,
	disabled = false,
	Icon,
	IconAfter,
	label,
}) {
	return <Button
		variant='text'
		size='small'
		color='primary'
		className={classes.button}
		onClick={onClick}
		disabled={disabled}
	>
		{Icon && <Icon />}
		{label}
		{IconAfter && <IconAfter />}
	</Button>
}


export default withStyles(style)(InfoBarTitleButton);